export default __webpack_public_path__ + "static/media/BGC_Page1_Icon.6af38b44.svg";